/*
 *   File : manage-basket.js
 *   Author : https://evoqins.com
 *   Description : Manage basket page
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { Fragment, useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Modal } from 'bootstrap/dist/js/bootstrap.min';
import { toast } from 'react-toastify';

//Custom components
import { AmountInput, CustomSearchInput, CustomSelectBox, CustomTextArea, CustomTextInput } from '../../Components/FormElements';
import { PrimaryButton, SecondaryButton, TextButton } from '../../Components/Buttons';
import { Icon } from '../../Components/Icon';
import { ConfirmModal, SearchFundModal } from '../../Components/Modal';
import { APIService } from '../../Service';

// styles
import color from '../../Style/color.scss';

const STATUS_DATA = [
    {
        id: 1,
        label: "Active",
    },
    {
        id: 2,
        label: "Inactive"
    }
];

const ManageBasket = () => {

    const isRendered = useRef(true);

    const navigate = useNavigate();
    const { state } = useLocation();
    const inputRef = useRef({});


    const [basketName, setBasketName] = useState("");
    const [basketNameError, setBasketNameError] = useState("");
    const [selectStatus, setSelectStatus] = useState(1);
    const [sipAmount, setSipAmount] = useState("");
    const [sipAmountError, setSipAmountError] = useState("");
    const [lumpsumAmount, setLumpsumAmount] = useState("");
    const [lumpsumAmountError, setLumpsumAmountError] = useState("");
    const [saveModal, setSaveModal] = useState(false);

    const [buttonLoader, setButtonLoader] = useState(false);

    const [addFund, setAddFund] = useState([
        {
            fund_type: "",
            allocation: "",
            fund_name: "",
        }
    ]);

    const [errors, setErrors] = useState([
        {
            fund_type: "",
            allocation: "",
            fund_name: ""
        }
    ]);

    const [fundType, setFundType] = useState(null);
    const [fundTypeError, setFundTypeError] = useState("");

    const [fundName, setFundName] = useState("");
    const [fundNameError, setFundNameError] = useState("");

    const [searchModal, setSearchModal] = useState(false);

    const [fundField, setFundField] = useState("");
    const [fundIndex, setFundIndex] = useState(null);

    const [fundTypeData, setFundTypeData] = useState([]);
    const [loader, setLoader] = useState(true);

    const [hovered, setHovered] = useState({});

    const [description, setDescription] = useState("");

    const [descriptionError, setDescriptionError] = useState("");

    const [allocationName, setAllocationName] = useState("");
    const [allocationNameError, setAllocationNameError] = useState("");

    useEffect(() => {
        window.scrollTo({
            top: 0, behavior: 'smooth'
        });
    }, []);

    // const _handleFocusError = (key) => {
    //     setTimeout(() => {
    //         if (key === 'description' && inputRef.current) {
    //             inputRef.current.parentNode.scrollIntoView({ behavior: "smooth", block: "center" });
    //             inputRef.current.focus();
    //         }
    //     }, 100); // Add a 100ms timeout
    // };

    useEffect(() => {
        if (state !== null) {
            console.log('ddje', state);
            if (state.basket_data) {
                if (state.selected_tab === 1 || state.selected_tab === 2) {
                    setDescription(state.basket_data.description);

                    if (state.basket_data.style_name) {
                        setBasketName(state.basket_data.style_name);
                        // setDescription(state.basket_data.description);
                    } else {
                        setBasketName(state.basket_data.basket_name);
                        // setDescription(state.basket_data.description);
                    }

                    if (state.basket_data.basket_investment_name) {
                        setAllocationName(state.basket_data.basket_investment_name);
                    } else {
                        setAllocationName('');
                    }

                    if (state.selected_tab === 2) {
                        if (state.basket_data.is_active === "Active") {
                            setSelectStatus(1);
                        } else {
                            setSelectStatus(2);
                        }
                    }

                    let formatted_sip = state.basket_data.min_sip.replace(/[^\d.]/g, '').split('.')[0];

                    setSipAmount(formatted_sip);

                    let formatted_lumpsum = state.basket_data.min_lumpsum.replace(/[^\d.]/g, '').split('.')[0];
                    setLumpsumAmount(formatted_lumpsum);

                    const transformed_data = state.basket_data.funds.map((fund) => ({
                        fund_type: { value: fund.fund_type, label: fund.asset_class },
                        allocation: parseFloat(fund.allocation.replace("%", "")).toString(),
                        fund_name: fund.fund_name,
                    }));
                    setAddFund(transformed_data);

                    let updated_errors = state.basket_data.funds.map(data => ({
                        fund_type: "",
                        allocation: "",
                        fund_name: "",
                    }));

                    setErrors(updated_errors)
                } else {
                    setFundName(state.basket_data.fund_name);
                    setFundType({ value: state.basket_data.fund_type, label: state.basket_data.asset_class })
                }
            }
        } else {
            navigate("/baskets");
            return;
        }

    }, [state]);

    useEffect(() => {
        if (isRendered.current === true) {
            _getFunds();
            isRendered.current = false;
        }
    }, [isRendered.current]);

    useEffect(() => {
        if (saveModal === true) {
            const save_modal = new Modal(document.getElementById("confirm-modal"));
            save_modal.show();
        }
    })

    useEffect(() => {
        if (searchModal == true) {
            const modal = new Modal(document.getElementById("search-fund-modal"));
            modal.show();
        }
    }, [searchModal]);

    useEffect(() => {
        setBasketNameError("");
    }, [basketName]);

    useEffect(() => {
        setAllocationNameError("");
    }, [allocationName]);

    useEffect(() => {
        setSipAmountError("");
    }, [sipAmount]);

    useEffect(() => {
        setLumpsumAmountError("");
    }, [lumpsumAmount]);

    useEffect(() => {
        setFundTypeError("");
    }, [fundType]);

    useEffect(() => {
        setFundNameError("");
    }, [fundName]);

    useEffect(() => {
        setDescriptionError("");
    }, [description]);

    // handle select status 
    const _handleSelectStatus = (id) => {
        setSelectStatus(id)
    };


    // handle change funds 
    // const _handleChangeFunds = (value, field, index) => {
    //     if (value === '' || (value <= 100 && String(value).length <= 3)) {
    //         setAddFund(prev => {
    //             const updated_fund = [...prev];
    //             updated_fund[index][field] = value;
    //             return updated_fund;
    //         });

    //         setErrors(prev => {
    //             const updated_errors = [...prev];
    //             updated_errors[index][field] = '';
    //             return updated_errors;
    //         })
    //     }
    // };
    const _handleChangeFunds = (value, field, index) => {
        if (field === 'allocation') {
            // only numeric validation for allocation
            if (value === '' || (value <= 100 )) {
                setAddFund(prev => {
                    const updated_fund = [...prev];
                    updated_fund[index][field] = value;
                    return updated_fund;
                });

                setErrors(prev => {
                    const updated_errors = [...prev];
                    updated_errors[index][field] = '';
                    return updated_errors;
                });
            }
        } else {
            // for other fields (like fund_type), update without validation
            setAddFund(prev => {
                const updated_fund = [...prev];
                updated_fund[index][field] = value;
                return updated_fund;
            });

            setErrors(prev => {
                const updated_errors = [...prev];
                updated_errors[index][field] = '';
                return updated_errors;
            });
        }
    };


    const _handleAmountChange = (value, setterFn) => {
        if (value === '' || (value <= 99999 && String(value).length <= 5)) {
            setterFn(value);
        }
    };

    // handle add more funds 
    const _handleAddMore = () => {
        setAddFund(prev => ([
            ...prev,
            {
                fund_type: "",
                allocation: "",
                fund_name: "",
            }
        ]));

        setErrors(prev => ([
            ...prev,
            {
                fund_type: "",
                allocation: "",
                fund_name: "",
            }
        ]));
    };

    // handle delete fund
    const _handleDelete = (index) => {
        setAddFund(prev => {
            const updated_fund = [...prev];
            updated_fund.splice(index, 1);
            return updated_fund;
        });

        setErrors(prev => {
            const updated_error = [...prev];
            updated_error.splice(index, 1);
            return updated_error;
        });
    };

    // handle cancel 
    const _handleCancel = () => {
        navigate("/baskets", {
            state: {
                tab_index: state.selected_tab,
                selected_year: 1,
                selected_year: state.duration
            }
        });
    };

    // handle search fund modal 
    const _handleSearchFund = (value = null, field, index) => {
        setFundIndex(index)
        setFundField(field);
        setSearchModal(true);
    };

    // handle selected fund  
    const _handleSelectedFund = (value) => {
        setSearchModal(false);

        if (fundIndex !== undefined) {
            setAddFund(prev => {
                const updated_fund = [...prev];
                updated_fund[fundIndex][fundField] = value.label;
                return updated_fund;
            });

            const updated_error = [...errors];
            updated_error[fundIndex][fundField] = '';
            setErrors(updated_error);
        } else {
            setFundName(value.label);
        }
    };

    // handle focus error
    const _handleFocusError = (key) => {
        setTimeout(() => {
            if (inputRef.current[key]) {
                inputRef.current[key].scrollIntoView({
                    behavior: 'smooth',
                    top: 0
                });
                inputRef.current[key].focus();
            }
        }, 100);
    };

    // handle create fund 
    const _handleSave = () => {
        let is_valid = true;
        let first_error_key = null;

        if (state.selected_tab === 1 || state.selected_tab === 2) {
            const updated_error = [...errors];

            if (state.selected_tab === 1 && allocationName.trim().length === 0) {
                setAllocationNameError("Please provide basket name");
                is_valid = false;
                first_error_key = first_error_key || "allocationName";
            }

            if (basketName.trim().length === 0) {
                setBasketNameError("Please provide strategy name");
                is_valid = false;
                first_error_key = first_error_key || "basketName";
            }

            if (description.trim().length === 0) {
                setDescriptionError("Please provide description");
                is_valid = false;
                first_error_key = first_error_key || "description";
            }

            if (sipAmount.trim().length === 0) {
                setSipAmountError("Please provide min sip amount");
                is_valid = false;
                first_error_key = first_error_key || "sipAmount";
            }
            if (lumpsumAmount.trim().length === 0) {
                setLumpsumAmountError("Please provide min lumpsum amount");
                is_valid = false;
                first_error_key = first_error_key || "lumpsumAmount";
            }

            addFund.forEach((fund, index) => {
                if (fund.fund_type === '') {
                    updated_error[index].fund_type = 'Please select fund type';
                    is_valid = false;
                    first_error_key = first_error_key || `fund_type_${index}`;
                }

                if (fund.allocation.trim().length === 0) {
                    updated_error[index].allocation = 'Please provide allocation';
                    is_valid = false;
                    first_error_key = first_error_key || `allocation_${index}`;
                }

                if (fund.fund_name.trim().length === 0) {
                    updated_error[index].fund_name = 'Please provide fund name';
                    is_valid = false;
                    first_error_key = first_error_key || `fund_name_${index}`;
                }
            });

            setErrors(updated_error);
        } else {

            if (fundType === null) {
                setFundTypeError("Please provide fund type");
                is_valid = false;
                first_error_key = first_error_key || "fundType";
            }

            if (fundName.trim().length === 0) {
                setFundNameError("Please provide provide fund name");
                is_valid = false;
                first_error_key = first_error_key || "fundName";
            }
        }

        if (is_valid === false && first_error_key) {
            _handleFocusError(first_error_key);
        } else {
            _upsert();
        }
    };

    // API - upsert
    const _upsert = () => {

        let updated_fund = null;
        if (state.selected_tab === 1 || state.selected_tab === 2) {
            updated_fund = addFund.map(fund => ({
                "fund_type": fund.fund_type.label,
                "allocation": fund.allocation,
                "fund_name": fund.fund_name
            }))
        } else {
            updated_fund = [{
                "fund_type": fundType.label,
                "fund_name": fundName
            }]
        }

        let is_post = true;
        let url = 'manage-basket/upsert';
        let request = {
            "investment_type": state.selected_tab,
            "duration": state.duration ? state.duration : null,
            "operation_type": state.edit === true ? null : 1,
            "investment_style_id": state.edit === true ? state.basket_data.style_id : null,
            "investment_type_id": state.edit === true ? state.basket_data.investment_type_id : null,
            "basket_name": basketName,
            "description": description,
            "basket_status": state.selected_tab === 2 ? selectStatus === 1 ? "ACTIVE" : "INACTIVE" : null,
            "min_sip": sipAmount.length === 0 ? null : sipAmount,
            "min_lumpsum": lumpsumAmount.length === 0 ? null : lumpsumAmount,
            "update_fund": updated_fund,
            "investment_name": state.selected_tab === 1 ? allocationName : null
        }

        setButtonLoader(true);
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                setSaveModal(true);
            } else {
                toast.dismiss();
                toast.error(response.message, { type: "error" });
            }
            setButtonLoader(false);
        });
    };

    // API - Get fund list
    const _getFunds = () => {
        let is_post = true;
        let url = 'manage-basket/get-fund';
        let request = {
            "query": "",
            "recommended_fund_query": false
        }
        setLoader(true);
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {

                let updated_fund_type = response.data.fund_type.map(data => ({
                    value: data.id,
                    label: data.name
                }))
                setFundTypeData(updated_fund_type);
            }
            else {
                setFundTypeData([]);
            }
            setLoader(false);
        });
    };


    if (state === null) {
        return navigate("/baskets");
    };

    return (
        <Fragment>
            <section className='e-section-height pb-5' >
                <div className='e-bg-lavender padding-52px-lr pt-2 padding-112px-bottom'>
                    <p className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-400 line-height-24px'>
                        <span className='text-decoration-hover-underline cursor-pointer'
                            onClick={_handleCancel}>Manage Baskets</span> / <span className='e-font-weight-600'>{state.edit === true ? 'Edit ' : 'Create new basket'}</span>
                    </p>
                </div>

                <div className='padding-52px-lr margin--80px-top'>
                    <div className='e-bg-white border-radius-16 padding-32px-lr padding-32px-top padding-68px-bottom'>
                        <h4 className='mb-4 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                            {state.edit === true ? 'Edit basket' : 'Create new basket'}
                        </h4>

                        {state.selected_tab === 1 || state.selected_tab === 2 ?
                            <>
                                <div className='row'>
                                    <div className='col-9'>
                                        <div className='row'>

                                            {state.selected_tab === 1 &&
                                                <div ref={el => inputRef.current["allocationName"] = el} className="col-6 ">
                                                    <CustomTextInput label="Basket name"
                                                        placeholder="Enter basket name"
                                                        type="text"
                                                        // autoFocus={true}
                                                        required={true}
                                                        value={allocationName}
                                                        error={allocationNameError}
                                                        className="w-100 "
                                                        inputType={2}
                                                        handleChange={(e) => {
                                                            setAllocationName(e)
                                                        }} />
                                                </div>
                                            }

                                            <div ref={el => inputRef.current["basketName"] = el} 
                                                className={state?.selected_tab === 1 ? "col-6 opacity-50 user-select-none pe-none " : "col-6"}>
                                                <CustomTextInput label={state?.selected_tab === 1 ? "Strategy name" : "Basket name"}
                                                    placeholder={state?.selected_tab === 1 ? "Enter strategy name" : "Enter basket name"}
                                                    type="text"
                                                    autoFocus={state.selected_tab === 2 ? true : false}
                                                    required={true}
                                                    value={basketName}
                                                    error={basketNameError}
                                                    className="w-100"
                                                    inputType={2}
                                                    handleChange={(e) => setBasketName(e)} />
                                            </div>

                                            {/* Select basket status */}
                                            {state.selected_tab == 2 &&
                                                <div className='col-6'>
                                                    <p className='mb-0 pt-4 e-text-chinese-black e-font-14 e-primary-font e-font-weight-400 line-height-18px padding-4px-bottom' >
                                                        Select basket status<span className='e-text-carmine-pink'>*</span>
                                                    </p>
                                                    <div className='pt-2 d-flex align-items-center gap-3'>
                                                        {STATUS_DATA.map((status, key) => (
                                                            <div key={key} className='d-flex align-items-center gap-2 cursor-pointer'
                                                                onClick={() => _handleSelectStatus(status.id)}>
                                                                <Icon icon={selectStatus === status.id ? "radio-active" : "radio-inactive"}
                                                                    size="1rem"
                                                                    className="d-flex" />
                                                                <p className='mb-0 e-text-dark-gray e-font-14 e-primary-font e-font-weight-400 line-height-18px'>
                                                                    {status.label}
                                                                </p>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            }
                                        </div>

                                        <div className='row pt-3'>
                                            <div ref={el => inputRef.current["description"] = el} className="col-12">
                                                <CustomTextArea label="Why choose this basket"
                                                    placeholder="Enter description"
                                                    type="text"
                                                    value={description}
                                                    error={descriptionError}
                                                    required={true}
                                                    className="w-100"
                                                    borderStyle="e-border-0-5px-arsenic"
                                                    handleChange={(e) => setDescription(e)}
                                                />
                                            </div>
                                        </div>


                                        {/* Update min SIP & Lumpsum  */}
                                        <div className='pt-4 mt-2'>
                                            <h6 className='mb-4 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-16px'>
                                                Update min SIP & Lumpsum
                                            </h6>
                                            <div className='row'>
                                                {/* Min SIP */}
                                                <div ref={el => inputRef.current["sipAmount"] = el} className='col-6'>
                                                    <AmountInput label="Min SIP"
                                                        placeholder="Enter amount"
                                                        required={true}
                                                        value={sipAmount}
                                                        error={sipAmountError}
                                                        className="w-100"
                                                        handleChange={(e) => _handleAmountChange(e, setSipAmount)} />
                                                </div>
                                                {/* Min Lumpsum * */}
                                                <div ref={el => inputRef.current["lumpsumAmount"] = el} className='col-6'>
                                                    <AmountInput label="Min Lumpsum"
                                                        placeholder="Enter amount"
                                                        required={true}
                                                        value={lumpsumAmount}
                                                        error={lumpsumAmountError}
                                                        className="w-100"
                                                        handleChange={(e) => _handleAmountChange(e, setLumpsumAmount)} />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Update funds  */}
                                        <div className='pt-4 mt-2'>
                                            <div className='pb-4 d-flex justify-content-between align-items-center'>
                                                <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-14 e-font-weight-600 line-height-16px'>
                                                    Update funds
                                                </h6>
                                                <div className='d-flex align-items-center gap-2px'>
                                                    <Icon icon='hint'
                                                        size="1rem"
                                                        className="d-flex" />
                                                    <p className='mb-0 e-text-arsenic e-primary-font e-font-12 e-font-weight-600 line-height-24px'>
                                                        Total allocation should be <span className='e-font-weight-700'>100%</span>
                                                    </p>
                                                </div>
                                            </div>

                                            {/* Added fund  */}
                                            {addFund.map((fund, key) => (
                                                <div key={key} className='row row-gap-3 pb-4 position-relative'>
                                                    {/* Fund type  */}
                                                    <div ref={el => inputRef.current[`fund_type_${key}`] = el} className='col-3'>
                                                        <CustomSelectBox title='Fund type'
                                                            placeholder='Select'
                                                            controlWidth='w-100'
                                                            required={true}
                                                            options={fundTypeData}
                                                            isSearchable={false}
                                                            borderColor={`0.031rem solid ${color.arsenic}`}
                                                            padding="0.8125rem 1rem"
                                                            value={fund.fund_type}
                                                            loader={loader}
                                                            error={errors[key]?.fund_type}
                                                            onChange={(data) => _handleChangeFunds(data, 'fund_type', key)} />
                                                    </div>

                                                    {/* Allocation  */}
                                                    <div ref={el => inputRef.current[`allocation_${key}`] = el} className='col-3'>
                                                        <CustomTextInput label="Allocation"
                                                            placeholder="Enter allocation"
                                                            type="number"
                                                            required={true}
                                                            value={fund.allocation}
                                                            error={errors[key]?.allocation}
                                                            className="w-100"
                                                            inputType={2}
                                                            showPercentage={true}
                                                            handleChange={(e) => _handleChangeFunds(e, 'allocation', key)} />
                                                    </div>

                                                    {/* Fund name  */}
                                                    <div ref={el => inputRef.current[`fund_name_${key}`] = el} className='col-6'
                                                        onClick={() => _handleSearchFund(null, "fund_name", key)}>
                                                        <CustomSearchInput label="Fund name"
                                                            placeholder="Search for funds"
                                                            type="text"
                                                            required={true}
                                                            clearIcon="top-18px right-16px"
                                                            value={fund.fund_name}
                                                            error={errors[key]?.fund_name}
                                                            className="w-100 e-caret-color-transparent cursor-pointer"
                                                            inputType={2} />
                                                    </div>

                                                    <Icon icon="delete"
                                                        size="1rem"
                                                        color={hovered[key] ? color.carmine_pink : null}
                                                        onMouseEnter={() => setHovered(prev => ({ ...prev, key: [true] }))}  // Change color on hover
                                                        onMouseLeave={() => setHovered(prev => ({ ...prev, key: [false] }))} // Reset color when not hovered
                                                        className={`${addFund.length === 1 ? 'e-disable' : ''} cursor-pointer position-absolute start-100 top-44px`}
                                                        onClick={() => _handleDelete(key)} />
                                                </div>
                                            ))}

                                            <div className='mt-2'>
                                                <TextButton name="Add Fund"
                                                    add={true}
                                                    onClick={_handleAddMore} />
                                            </div>
                                        </div>

                                        <div className='padding-40px-top d-flex justify-content-end gap-3'>
                                            <SecondaryButton name="Cancel"
                                                className="padding-52px-lr"
                                                onClick={_handleCancel} />
                                            <PrimaryButton name={state.edit === true ? ' Save & Update' : 'Create'}
                                                className={`${state.edit === true ? 'padding-26px-lr' : 'padding-52px-lr'} ${buttonLoader ? "w-141px" : ""}`}
                                                paddingBlock="padding-12px-tb "
                                                loader={buttonLoader}
                                                onClick={_handleSave} />
                                        </div>
                                    </div>
                                </div>
                            </>
                            :

                            // Update funds
                            <>
                                <h4 className='mb-4 e-text-smoky-black e-primary-font e-font-14 e-font-weight-600 line-height-16px'>
                                    Update funds
                                </h4>
                                <div className='row'>
                                    <div className='col-9'>
                                        <div className='row'>
                                            {/* Fund type */}
                                            <div className="col-4">
                                                <CustomSelectBox title='Fund type'
                                                    placeholder='Select'
                                                    controlWidth='w-100'
                                                    required={true}
                                                    options={fundTypeData}
                                                    isSearchable={false}
                                                    borderColor={`0.031rem solid ${color.arsenic}`}
                                                    padding="0.8125rem 1rem"
                                                    value={fundType}
                                                    error={fundTypeError}
                                                    onChange={(data) => setFundType(data)} />
                                            </div>

                                            {/* Fund name  */}
                                            <div className='col-6'
                                                onClick={_handleSearchFund}>
                                                <CustomSearchInput label="Fund name"
                                                    placeholder="Search for funds"
                                                    type="text"
                                                    required={true}
                                                    value={fundName}
                                                    error={fundNameError}
                                                    className="w-100 e-caret-color-transparent cursor-pointer"
                                                    inputType={2} />
                                            </div>
                                        </div>

                                        <div className='padding-40px-top d-flex justify-content-end gap-3'>
                                            <SecondaryButton name="Cancel"
                                                className="padding-52px-lr"
                                                onClick={_handleCancel} />
                                            <PrimaryButton name={state.edit === true ? ' Save & Update' : 'Create'}
                                                className={`${state.edit === true ? 'padding-26px-lr' : 'padding-52px-lr'} ${buttonLoader ? "w-141px" : ""}`}
                                                paddingBlock="padding-12px-tb "
                                                loader={buttonLoader}
                                                onClick={_handleSave} />
                                        </div>
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                </div>
            </section>

            {/* Save success modal */}
            {saveModal === true &&
                <ConfirmModal title={state.edit === true ? 'Updated!' : 'New basket created successfully'}
                    description={state.edit === true ? 'Basket updated successfully! Your recent changes have been applied and saved.' : `The new basket has been added to Thematic baskets`}
                    handleClose={() => {
                        setSaveModal(false);
                    }}
                    handleSuccess={() => {
                        setSaveModal(false);
                        navigate('/baskets', {
                            state: {
                                tab_index: state.selected_tab,
                                selected_year: state.duration
                            }
                        })
                    }}
                />
            }

            {/* Search fund modal */}
            {searchModal === true &&
                <SearchFundModal
                    handleClose={() => {
                        setTimeout(() => {
                            setSearchModal(false);
                        }, 200);
                    }}
                    handleSuccess={_handleSelectedFund} />
            }
        </Fragment >
    )
}

export default ManageBasket;
